@if (!opfoelgning) {
  <div class="opfoelgning-list">
    <h1 mat-dialog-title class="orange" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>
      <mat-icon svgIcon="bookmark-solid" class="orange"></mat-icon>
      Opfølgninger for {{ title }} {{ serviceordre?.serviceordreNo ?? data.okKundeAftaleNr ?? data.entityNo }}
    </h1>
    <button class="btn-close btn-icon" mat-dialog-close title="Luk dialog">
      <mat-icon class="material-icons">close</mat-icon>
    </button>
    <div mat-dialog-content>
      <div class="opfoelgning-row opfoelgning-row__create">
        <button (click)="onCreate()" class="btn-icon green">
          <mat-icon svgIcon="add"></mat-icon>
          <span>Opret ny</span>
        </button>
      </div>
      @for (opfoelgning of opfoelgninger; track opfoelgning) {
        <div class="opfoelgning-row">
          <div class="opfoelgning-row__details" (click)="onSelect(opfoelgning)">
            <div>
              <div class="coin coin--{{ coin_color(opfoelgning.priority) }}"></div>
              @if (opfoelgning.deadline) {
                <span>Deadline: {{ opfoelgning.deadline | date }}</span>
              }
              <span
                class="timestamp"
            title="Opfølgning oprettet {{
              opfoelgning.createdOn | amLocale : 'da' | amCalendar : { sameElse: 'DD.MM.YYYY [kl.] HH.mm' }
            }} af {{ opfoelgning.user }}"
                >
                <mat-icon class="cursor-help" svgIcon="avatar"></mat-icon>
              </span>
            </div>
            <div class="">{{ opfoelgning.note }}</div>
          </div>
          @if (canEdit(opfoelgning)) {
            <button mat-icon-button (click)="onSelect(opfoelgning)">
              <mat-icon class="opfoelgning-row__view" svgIcon="table-arrow"></mat-icon>
            </button>
          }
        </div>
      }
    </div>
  </div>
} @else {
  <h1 mat-dialog-title cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle>Følg op</h1>
  <button class="btn-close btn-icon" (click)="onClose()" title="Luk dialog">
    <mat-icon class="material-icons">close</mat-icon>
  </button>
  <div mat-dialog-content>
    @if (!canSave) {
      <div class="orange align-center med-text">
        <mat-icon svgIcon="obs-solid" class="icon-48"></mat-icon>
        <br />
        Du kan ikke redigere andres opfølgninger.
      </div>
    }
    <form [formGroup]="form" autocomplete="off">
      <div class="form-row">
        <mat-radio-group aria-labelledby="priority-radio-group-label" class="priority-radio-group" formControlName="prioritet">
          <mat-label>Prioritet</mat-label>
          <mat-radio-button class="priority-radio-button red" [value]="1">Høj</mat-radio-button>
          <mat-radio-button class="priority-radio-button orange-prio" [value]="2">Middel</mat-radio-button>
          <mat-radio-button class="priority-radio-button grey-prio" [value]="3">Lav</mat-radio-button>
        </mat-radio-group>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" color="primary">
          <mat-label>Deadline</mat-label>
          <input #input matInput [matDatepicker]="picker" formControlName="deadline" />
          <mat-datepicker-toggle matPrefix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field appearance="outline" class="mdc-textarea-fix">
          <mat-label>Egen note</mat-label>
          <textarea id="note" placeholder="Bemærkning..." formControlName="note" rows="2" matInput type="text"></textarea>
        </mat-form-field>
      </div>
      @if (
        serviceordre?.serviceordreStateEnum == serviceordreStatusEnum.CompletedWithAccounting ||
        serviceordre?.serviceordreStateEnum == serviceordreStatusEnum.Parked
        ) {
        <div
          class="form-row flex"
          >
          <mat-slide-toggle color="primary" formControlName="parker">
            <div class="flex">
              <mat-icon svgIcon="park"></mat-icon>
              <span class="margin--left-xs">Parkér ordre</span>
            </div>
          </mat-slide-toggle>
          <app-info tooltip="Hvad betyder det?" class="margin--left-xs" (click)="parkerinfo($event)"></app-info>
        </div>
      }
    </form>
  </div>
  <div mat-dialog-actions class="row-reverse">
    @if (canSave) {
      <button mat-raised-button color="primary" (click)="save()" [disabled]="form.invalid">Gem</button>
    }
    @if (canRemove) {
      <button class="modal-cancel" (click)="remove()" mat-raised-button>Fjern</button>
    }
  </div>
}
